import React from "react";
import { Chart, Line, Point, Tooltip, Axis } from "bizcharts";

const FraudCheckLineChart = (props) => {
    const { t, data } = props;

    return (
        <div>
            <Chart
                height={400}
                autoFit
                data={data}
                scale={{ total: { min: 0, tickCount: 3, alias: t("contents.dashboard.total") } }}
            >
                <Tooltip shared />
                <Axis
                    name="value"
                    title={{
                        position: "center",
                    }}
                />

                <Line
                    position="date*value"
                    color={[
                        "type",
                        (type) =>
                            type === "APPROVED"
                                ? "#64C094"
                                : "#EC6B74"
                    ]}
                    shape="smooth"
                />

                <Point
                    position="date*value"
                    color={[
                        "type",
                        (type) =>
                            type === "APPROVED"
                                ? "#64C094"
                                : "#EC6B74"
                    ]}
                />
            </Chart>
        </div>
    );
};

export default FraudCheckLineChart;
